import { MultiViewsElement } from "@ortho-next/three-base";
import { CustomCameraControls } from "./CustomCameraControls.js";
/**
 * MultiViewsElement with a camera control.
 */
export class MultiViewsElementCustom extends MultiViewsElement {
    constructor(viewType, parameters, cameraControlsProto = CustomCameraControls) {
        super(parameters);
        this.cameraControls = new cameraControlsProto(this.camera, viewType, this.parameters.width, this.parameters.height);
    }
}
//# sourceMappingURL=MultiViewsElementCustom.js.map